import { useQuery } from '@tanstack/react-query';

import { useMySubscriptions } from '../subscriptions';

import { useLiveRecordFilterStore } from './useLiveRecordFilterStore';

import { sdk } from '@/services';

const EventService = sdk.getService('EventService');

export const useStudentLiveRecordsByCourse = (courseIdOverride?: string) => {
  const { selectedSubscription } = useMySubscriptions();
  const { filter } = useLiveRecordFilterStore();
  const courseId = courseIdOverride || selectedSubscription?.course._id;

  const { data, isLoading, error } = useQuery({
    queryKey: ['events', 'live-records', courseId, filter],
    queryFn: () => EventService.getCourseLiveRecords(courseId!, filter),
    enabled: !!courseId
  });

  return {
    liveRecords: data,
    isLoading,
    error
  };
};
